module.exports = __webpack_public_path__ + "img/category-casino-hover.1e07f20f.png";